import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Alert from 'react-bootstrap/Alert'
import { Offcanvas } from 'react-bootstrap'
import { PanelFooter, PanelHeader } from 'components/Panel'

function VerRegulacion(props) {
	const { regulacion, setQueMostrar } = props

	const handleClose = () => {
		setQueMostrar('')
	}

	const nombreOriginalArchivoPartes = regulacion.documento?.url.split('/')
	const nombreOriginalArchivo = nombreOriginalArchivoPartes[nombreOriginalArchivoPartes.length - 1]
	const extensionPartes = nombreOriginalArchivo.split('.')
	const extension = extensionPartes[extensionPartes.length - 1]

	const isPdf = extension === 'pdf'
	const isDoc = extension === 'docx' || extension === 'doc'

	// render
	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" scroll="true" responsive="lg">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Ver regulación sanitaria" />
			<Offcanvas.Body id="ver-regulacion">
				<h1>Campos de la regulación sanitaria</h1>
				{regulacion.borrador ? (<Row>
					<Col sm={12} md={6}>
						<Alert variant="warning">Esta regulación sanitaria está en modo borrador.</Alert>
					</Col>
				</Row>) : null}
				<Row>
					<Col>
						<label>Título</label>
						<div className="titulo">
							{regulacion.titulo}
						</div>
					</Col>
				</Row>
				<Row>
					<Col className="mb-2">
						<label>Contenido</label>
						<div className="contenido">
							{regulacion.contenido}
						</div>
					</Col>
				</Row>
				<Row className="mb-3">
					<Col>
						<label>Fecha</label>
							<div className="fecha">
								{regulacion.fecha.substr(0, 16)}
							</div>
					</Col>
				</Row>
				<Row>
					<Col>
						<label>Documento</label>
						<div>
						<i className={'fa ' + (isDoc ? 'fa-file-word' : (isPdf ? 'fa-file-pdf' : 'fa-file'))}></i> <a href={process.env.REACT_APP_API_URL + 'uploads/' + regulacion.documento.url}>{nombreOriginalArchivo}</a>
						</div>
					</Col>
				</Row>
			</Offcanvas.Body >
		<PanelFooter>
			<Button variant="outline-primary" onClick={handleClose} className="me-2">
				Ok
			</Button>
		</PanelFooter>
		</Offcanvas >
	)
}

export default VerRegulacion